import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TypePattern"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 11.25H12.75V1.5H11.25V11.25H1.5V12.75H11.25V22.5H12.75V12.75H22.5V11.25ZM5.25 9C3.17893 9 1.5 7.32107 1.5 5.25C1.5 3.17893 3.17893 1.5 5.25 1.5C7.32107 1.5 9 3.17893 9 5.25C8.99752 7.32004 7.32004 8.99752 5.25 9ZM21 9H16.5C15.6719 8.99917 15.0008 8.32808 15 7.5V3C15.0008 2.17192 15.6719 1.50083 16.5 1.5H21C21.8281 1.50083 22.4992 2.17192 22.5 3V7.5C22.4992 8.32808 21.8281 8.99917 21 9ZM19.1895 15L20.25 16.0605L17.5605 18.75L20.25 21.4395L19.1895 22.5L15.4395 18.75L19.1895 15ZM8.24989 22.5H2.24989C1.99006 22.4999 1.74881 22.3653 1.61224 22.1442C1.47568 21.9232 1.46325 21.6472 1.57939 21.4148L4.57939 15.4148C4.72017 15.1783 4.97505 15.0334 5.25026 15.0334C5.52548 15.0334 5.78036 15.1783 5.92114 15.4148L8.92114 21.4148C9.03734 21.6473 9.02484 21.9234 8.88809 22.1445C8.75134 22.3656 8.50985 22.5001 8.24989 22.5ZM5.24996 17.427L7.03646 21H3.46346L5.24996 17.427ZM16.5 7.5V3H21L21.0007 7.5H16.5ZM3 5.25C3 4.00736 4.00736 3 5.25 3C6.49213 3.00124 7.49876 4.00787 7.5 5.25C7.5 6.49264 6.49264 7.5 5.25 7.5C4.00736 7.5 3 6.49264 3 5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TypePattern.vue"]]);
